import { render } from "./App.vue?vue&type=template&id=56155da2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=56155da2&lang=css"

import exportComponent from "C:\\Projects\\HexagonMaritime\\_GIT\\purus-maritime\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__